export const SHIPPING_TYPE = ["Standard", "3 Day Select", "2 Day", "Next Day"];
